import React, { useContext, useEffect } from "react";
import { Popup, NavigationControl, FlyToInterpolator } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import layerConfig from "./layerConfig";
import styled, { createGlobalStyle } from "styled-components";
import Map from "./Map";
import { MapContext } from "./MapContext";
import ParticipateInfo from "./ParticipateInfo";
import ParticipateMessages from "./ParticipateMessages";

import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { AppContext } from "./AppContext";
import { Box } from "@material-ui/core";

function App() {
  /**
   * Get ref to map so we can add layers and such
   */
  const {
    mapRef: { current: map }
  } = useContext(MapContext);
  const handleOnLoad = async () => {
    map.addSource("engagements", {
      type: "geojson",
      data:
        "https://services1.arcgis.com/KGdHCCUjGBpOPPac/arcgis/rest/services/ParticipateEngagements_WFL1/FeatureServer/0/query?where=Status='Active' OR Status='Open'&f=pgeojson&returnIdsOnly=false&outSR=4326&outFields=*"
    });

    map.addLayer(layerConfig);
  };

  const { breakpoints } = useTheme();
  const sm = useMediaQuery(breakpoints.down("sm"));
  const { viewState, setViewState } = useContext(MapContext);

  const {activeFeature, setActiveFeature} = useContext(AppContext);
  const handleOnClick = ({ features }) => {
    const feature = features[0];
    if (feature && feature.source === "engagements") {
      setActiveFeature(feature);
      const [longitude, latitude] = feature.geometry.coordinates;
      const {zoom} = viewState;
      const latOffset = sm ? zoom * 0.0006 : 0;
      setViewState(vs => ({
        ...vs,
        latitude: latitude + latOffset,
        longitude,
        transitionDuration: 500,
        transitionInterpolator: new FlyToInterpolator(),
        transitionEasing: t =>
          t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t
      }));
    } else {
      setActiveFeature();
    }
  };

  /**
   * restrict bounds
   */
  const { setBounds } = useContext(MapContext);
  useEffect(() => {
    setBounds([
      [144.9, -37.85], // Southwest coordinates
      [144.99, -37.78] // Northeast coordinates
    ]);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <GlobalStyle />
      <ParticipateMessages />
      <Map
        maxPitch={0}
        minZoom={13}
        maxZoom={17}
        dragRotate={false}
        onLoad={handleOnLoad}
        onClick={handleOnClick}
        mapStyle="mapbox://styles/gisfeedback/cjxmggskq1smt1cryqlo09d2u?fresh=true"
        width="100vw"
        height="100vh"
        mapboxApiAccessToken="pk.eyJ1IjoiZ2lzZmVlZGJhY2siLCJhIjoiY2pzeTNrcmxqMDhpbjQ0cGZ6d3pteng1cCJ9.BWEwpntKJgZWwu5qw3hpsA"
      >
        {activeFeature && (
          <ComPopup
            longitude={activeFeature.geometry.coordinates[0]}
            latitude={activeFeature.geometry.coordinates[1]}
            onClose={() => setActiveFeature()}
          >
            <ParticipateInfo feature={activeFeature} />
          </ComPopup>
        )}
        <Box zIndex={99} position="absolute" right={24} top={{md: 24}} bottom={{xs: 24, md: 'auto'}}>
          <NavigationControl />
        </Box>
      </Map>
    </>
  );
}

export default App;

const GlobalStyle = createGlobalStyle`
  body,
  html {
    margin: 0;
  }
`;

const ComPopup = styled(Popup)`
  max-width: 360px;
`;

// https://developers.arcgis.com/rest/services-reference/query-feature-service-.htm
// https://services1.arcgis.com/KGdHCCUjGBpOPPac/arcgis/rest/services/ParticipateEngagements_WFL1/FeatureServer/0/query?where=Status='Active'&f=pgeojson&returnIdsOnly=false&outFields=*
